<template>
  <div class="tab-pane fade show active">
    <div class="no-wishlist" v-if="obData.items.length<=0">
      <div class="no-wish-tit">
        {{obData.messages.emptyList}}
      </div>
      <div class="no-wish-link">
        <a href="#" data-toggle="modal" data-target="#createList">
          {{obData.messages.emptyListBtn}}
        </a>
      </div>
    </div>
    <div class="wish-block" v-if="obData.items.length>0">
      <div class="one-wish-wrap" v-for="item in lists">
        <div class="one-wish-tit">
          {{item.name}}
        </div>
        <div class="one-wish-num">
          {{Object.keys(item.items).length}} {{obData.messages.savedElements}}
        </div>
        <div class="one-wish" :class="'wish-'+item.type+'-view'">
          <div class="one-wish-in">
            <div class="one-wish-top">
              <div class="one-wish-item" v-for="block in getProds(item.items)">
                <div class="one-wish-thumb">
                  <span>
                    <a :href="block.link">
                      <img :src="block.picture" alt="">
                    </a>
								  </span>
                </div>
              </div>
              <div class="one-wish-item" v-for="i in getEmptyBlock(item.type,getProds(item.items).length)"></div>
            </div>
            <div class="one-wish-bot">
              <a :href="item.link" class="border-bt">
                {{obData.messages.showListBtn}}
              </a>
              <a href="#" class="border-bt wish-delete" :data-wishlist="item.id">
                {{obData.messages.delBtn}}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="one-wish-wrap add-new">
        <div class="add-bt-list">
          <a href="#" data-toggle="modal" data-target="#createList">
					<span>
						<i></i>
            {{obData.messages.titleNewList}}
					</span>
          </a>
        </div>
      </div>
    </div>
    <div class="modal fade min-modal" id="createList" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          <div class="change-pass-modal">
            <div class="change-pass-descr">
              {{obData.messages.newListTitle}}
            </div>
            <div class="change-pass-form">
              <div class="change-pass-inp">
                <input type="text" name="addWishList">
              </div>

              <div class="change-pass-inp">
                <button class="def-bt light">
                  {{obData.messages.save}}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "personalfavorites",
  selector: '.personalfavorites',
  props:{params: Object},
  data() {
    return {
      obData:this.params,
    };
  },
  computed:{
    lists() {
      let list = [];
      for(let item in this.obData.items) {
        let kol = Object.keys(this.obData.items[item].items).length;
        if(kol !== 0) {
          let t = 0;
          if(kol <= 2) {
            t = 2;
          } else if(kol > 2 && kol <=4){
            t = 4;
          } else {
            t = 5;
          }
          this.obData.items[item]['type'] = t;
          list.push(this.obData.items[item]);
        }
      }
      return list;
    }
  },
  methods:{
    getProds(items) {
      let res = [];
      let iterator = 0;
      for (let index in items) {
        iterator++;
        if(iterator >= 6) break;
        res.push(items[index]);
      }
      return res;
    },
    getEmptyBlock(type,issetCount) {
      let res = [];
      for(let i=0;i<type-issetCount;i++) {
        res.push([]);
      }
      return res;
    }
  }
}
</script>

<style scoped>

</style>